import React from "react";

import "./About.css";

function About() {
  return (
    <div className="About">
      <div className="About-wrapper">
        <h1>À propos</h1>
		<p>
		  Le Compteur RIP est une initiative citoyenne élaborée par le Discord Insoumis.
		</p>
		<p>
		  Le Discord Insoumis est une communauté en ligne de militant•e•s soutenant le 
		  mouvement La France Insoumise et son programme l'Avenir en Commun. En accord avec 
		  nos principes de démocratie ouverte et de participation citoyenne, ce site n'a pas 
		  vocation à être partisan ou exclusivement au service de nos engagements politiques. 
		  La démarche se veut objective et nous souhaitons avant tout que chacun•e puisse 
		  obtenir des informations utiles la progression du référendum d'initiative 
		  populaire (RIP) en cours contre la privatisation d'Aéroports de Paris (ADP). Pour 
		  le moment, nous mettons à disposition un compteur du nombre de signataires. 
		  D'autres données sur ce RIP seront mises en ligne dans les semaines et mois à venir.
		</p>
		<p>
		  Si vous trouvez une erreur, un bug ou si vous souhaitez nous faire parvenir une 
		  remarque, envoyez-nous un e-mail à l'adresse suivante : Compteur.RIP ( at ) gmail.com
		</p>
		<p>
          Notre travail est bénévole, les coûts d'hébergement et d'infrastructure sont 
		  couverts par des dons.
		</p>
		<h1>Méthodologie</h1>
        <p>
          Pour obtenir cette estimation du nombre de signataires pour le RIP contre la 
		  privatisation d'ADP, nous avons mis en place un outil numérique d'apprentissage 
		  profond pour résoudre les CAPTCHAS qui sont ridiculement nombreux sur ce site 
		  (au point de nous faire penser qu'il s'agisse en fait d'une fonctionnalité pour 
		  limiter le nombre de signataires d'une part, et restreindre drastiquement la 
		  supervision que les citoyens devraient être en droit d'exercer d'autre part). 
		  Aucun travailleur pauvre payé au lance-pierre n'est utilisé 
		  pour résoudre les CAPTCHAS, comme c'est le cas parfois ailleurs.
        </p>
        <p>
          Quant à la fonctionnalité de recherche que nous vous proposons, aucune
          donnée personnelle n'est stockée ni copiée dans notre base de
          données. Lors de l'accès à la liste des signataires, les noms et
          prénoms sont d'abord normalisés puis les chaines "nom|prenoms" et
          "nom|premier prenom" sont hachées en utilisant le "Secure Hash Algorithm 2"
          (SHA2). C'est cette donnée anonyme que nous stockons, ainsi que la
          commune associée. En faisant une recherche du type "nom et prénom" sur notre site, 
		  cette information est hachée et comparée aux données déjà stockées, permettant de retrouver
		  les correspondance. L'outil retourne ensuite la ou les commune(s) associée(s).
		  L'opération inverse (retrouver un couple nom|prénom depuis 
		  les données que nous stockons) est mathématiquement impossible, ce qui fait que 
		  même en cas de vol et/ou piratage de notre base de données, aucune information 
		  nominative ne pourra jamais être récupérée.
        </p>
		<p>
		  Nous vous invitons à aller comparer nos estimations avec le compteur collaboratif 
		  mis en place par David Libeau <a href="https://dav.li/rip-le-compteur">(https://dav.li/rip-le-compteur)</a>, 
		  ainsi que celui de Benjamin Sonntag <a href="https://adp.sonntag.fr/">(https://adp.sonntag.fr/)</a>.
		</p>
        <h1>Politique de confidentialité</h1>
        <h2>Statistiques et mesures d'audience</h2>
        <p>
          Nous nous réservons le droit de collecter les IP pour parer
          d'éventuelles attaques DDOS ou "flood". Nous n'utilisons aucun cookie
          sur le site. Des statistiques anonymes (seulement reliées aux IP et
          non aux utilisateurs, en accord avec la RGPD) pourraient être
          collectées. Les logs de connexion du serveur sont conservés pour une
          durée de 7 jours conformément aux{" "}
          <a href="http://curia.europa.eu/juris/document/document.jsf?text=&amp;docid=186492&amp;pageIndex=0&amp;doclang=FR&amp;mode=lst&amp;dir=&amp;occ=first&amp;part=1&amp;cid=216378">
            dispositions européennes
          </a>{" "}
          en matière de rétention de données.
        </p>
        <h2>Accès aux données</h2>
        <p>
          Conformément à la loi Informatique et Liberté 78-17 du 6 janvier 1978
          modifiée, l'utilisateur dispose d'un droit d'opposition (art. 38),
          d'accès (art. 39), de rectification ou de suppression (art. 40) des
          données qui le concernent.
        </p>
        <p>
          Il peut exercer ce droit en nous contactant directement par courrier
          électronique à l'adresse Compteur.RIP (at) gmail.com.
        </p>
        <h2>Litiges</h2>
        <p>
          La loi applicable au présent contrat est la loi française. Dans toute
          hypothèse où un choix de loi serait possible, les parties conviennent
          que la loi applicable est la loi française.
        </p>
        <h1>Mentions légales</h1>
        <p>
          Le site <a href="http://compteur.rip">Compteur.RIP</a> est un service
          de communication au public en ligne qui est édité à titre non
          professionnel (au sens de{" "}
          <a href="https://www.legifrance.gouv.fr/affichTexte.do?cidTexte=JORFTEXT000000801164#LEGIARTI000032400316">
            l'article 6, III-2 de la Loi n° 2004-575 du 21 juin 2004 pour la
            confiance dans l'économie numérique
          </a>
          ). En accord avec les dispositions de l'article sus-cité, l'auteur de
          ces lignes a donc choisi de conserver l'anonymat.
        </p>
        Ces informations ont toutefois été transmises à l'hébergeur de ce site
        qui saura les délivrer à qui de droit.
        <h2>Hébergeur</h2>
        <p>
          Le prestataire technique qui assure l'hébergement de la base de
          données de <a href="http://compteur.rip">Compteur.RIP</a> est la
          société Online SAS, filiale du groupe Iliad, dont le siège social se
          situe au 8 rue de la ville l'Évêque, 75008 Paris.
        </p>
        <p>
          Online SAS
          <br />
          BP 438
          <br />
          75366 Paris
          <br />
          CEDEX 08
          <br />
          Site Internet : http//www.online.net/
          <br />
          Téléphone :+33 173 503 175
          <br />
          Télécopieur : +33 899 193 775 (1,35€ par appel puis 0,34€ / min)
          <br />
        </p>
        <p>
          La partie "front" du site (pages statiques) est hébergée par{" "}
          <a href="https://gitlab.com">GitLab.com</a> via leur fonctionnalité
          GitLab Pages.
        </p>
        <p>La société GitLab Inc. peut être contactée à l'adresse suivante :</p>
        <p>
          268 Bush Street #350
          <br />
          San Francisco, CA 94104
          <br />
          United States of America
          <br />
        </p>
      </div>
    </div>
  );
}

export default About;
